<template>
  <section
    v-loading="loading"
    id="view-lab"
    class="new-case-view case-creation"
  >
    <div class="container-sm">
      <div class="case-creation__step case-creation__patient-information">
        <div class="case-creation__card">
          <div class="edit-block">
            <el-button class="edit-btn" @click="gotoEditLab">
              <span class="edit-icon">
                <img
                  src="@/assets/images/icons/edit-case-information.svg"
                  alt=""
                />
                <p>EDIT</p>
              </span>
            </el-button>
          </div>
          <div class="case-creation__body pb-0">
            <div class="hospital-form vue-form" v-if="getSingleLab">
              <el-row :gutter="20">
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Lab Name</h4>
                    <p class="value">{{ getSingleLab.name }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Lab Code</h4>

                    <p class="value">{{ getSingleLab.lab_code }}</p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Phone Number</h4>
                    <p class="value">{{ getSingleLab.phone }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Fax</h4>
                    <p class="value">{{ getSingleLab.fax }}</p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Email</h4>
                    <p class="value">{{ getSingleLab.email }}</p>
                  </div>
                </el-col>

                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 1</h4>
                    <p class="value">{{ getSingleLab.address_line_1 }}</p>
                  </div>
                </el-col>
                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 2</h4>
                    <p class="value">{{ getSingleLab.address_line_2 }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Zip</h4>
                    <p class="value">{{ getSingleLab.zip }}</p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="3" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">City</h4>
                    <p class="value">{{ getSingleLab.city }}</p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">State</h4>
                    <p class="value">{{ getSingleLab.state }}</p>
                  </div>
                </el-col>

                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">County</h4>
                    <p class="value">{{ getSingleLab.country }}</p>
                  </div>
                </el-col>
                <el-col :xl="7" :lg="7" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Website</h4>
                    <p class="value">{{ getSingleLab.website }}</p>
                  </div>
                </el-col>
                <el-col :xl="6" :lg="6" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Director</h4>
                    <p class="value">{{ getSingleLab.director }}</p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">CLIA Id</h4>
                    <p class="value">{{ getSingleLab.clia_id }}</p>
                  </div>
                </el-col>
                <el-col :xl="4" :lg="4" :md="8" :sm="8" :xs="24">
                  <div class="input-value view-cases">
                    <h4 class="name">Accession Letter</h4>
                    <p class="value">{{ getSingleLab.accession_letter }}</p>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
        <span class="case-creation__divider"></span>

        <div class="case-creation__card">
          <div class="upload-lab-logo">
            <el-row :gutter="40">
              <el-col :xl="12" :lg="12" :md="8" :sm="8" :xs="24">
                <div class="lab-logo">
                  <h3>LAB LOGO</h3>
                  <div class="preview-image">
                    <img
                      v-if="getLabLogo || (getSingleLab && getSingleLab.logo)"
                      :src="getLabLogo || getSingleLab.logo"
                    />
                  </div>
                </div>
              </el-col>
              <el-col :xl="12" :lg="12" :md="8" :sm="8" :xs="24">
                <div class="admin-lab-view-upload-logo">
                  <el-upload
                    class="upload-demo"
                    drag
                    :limit="1"
                    action
                    :on-change="handleUpload"
                    :on-remove="handleRemove"
                    :auto-upload="false"
                    :multiple="false"
                    v-model:file-list="fileList"
                    ref="logoUpload"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload-text-align">
                      <div class="el-upload__text">
                        <img
                          src="@/assets/images/icons/attachments-icon.svg"
                          alt=""
                        />
                        <h3>Add file or Drag & drop file here</h3>
                      </div>
                    </div>
                  </el-upload>

                  <p class="err ml-10 pb-5" v-if="getLabLogoUpdateError">
                    {{ getLabLogoUpdateError }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="case-creation__actions">
          <ul class="list">
            <li>
              <el-button
                type="success"
                class="btn upload-button"
                @click="submitFileUploadDetails"
                :disabled="disableSubmitButton"
              >
                <span class="mr-8">
                  <img src="@/assets/images/icons/upload-file.svg" alt="icon" />
                </span>
                UPLOAD FILES
              </el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      loading: false,
      showUploadedFiles: false,
      formData: {},
      selectedFile: {},
      file_name: "",
      fileList: [],
      files: [],
      updateFileStatus: {
        files: [],
      },
      filesData: {
        files: [],
      },
      disableSubmitButton: true,
      message: "",
      selectedAccessionIds: [],
      inputVisible: false,
      inputValue: "",
      success: "",
    };
  },
  computed: {
    ...mapGetters("labs", [
      "getSingleLab",
      "getLogoAddStatus",
      "getLabLogo",
      "getLabLogoUpdateError",
    ]),
    labId() {
      return this.$route.params.lab_id;
    },
  },
  async mounted() {
    await this.getLabData();
    this.$store.commit("labs/setLabLogoUpdateError", "", {
      root: true,
    });
  },
  methods: {
    async gotoEditLab() {
      let id = this.$route.params.lab_id;
      this.$router.push({
        path: "/edit-lab",
        name: "EditLab",
        params: {
          lab_id: id,
        },
        query: { ...this.$route.query },
      });
    },
    async getLabData() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "labs/fetchSingleLab",
          this.$route.params.lab_id
        );
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.loading = false;
      }
    },
    handleRemove(file) {
      let uids = this.files.map(function (file) {
        return file.raw.uid;
      });
      const index = uids.indexOf(file.raw.uid);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    handleUpload(file) {
      file.status = "success";
      file.percentage = 100;
      this.disableSubmitButton = false;
      this.selectedFile = file.raw;
    },

    async submitFileUploadDetails() {
      this.loading = true;
      this.disableSubmitButton = true;

      let params = {
        lab_id: this.labId,
        logo: this.selectedFile,
      };
      await this.$store.dispatch("labs/uploadLogo", params);
      this.disableSubmitButton = false;
      this.loading = false;
      if (this.getLogoAddStatus) {
        this.$notify({
          title: "Success",
          message: "Logo Uploaded successfully",
          type: "success",
        });
        this.selectedFile = "";
        this.fileList = [];
        this.$refs.logoUpload.clearFiles();
      } else if (!this.getLabLogoUpdateError) {
        this.$notify({
          title: "Error",
          message: "Error at uploading ",
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="scss">
#view-lab {
  .case-creation__card {
    position: relative;
  }
  .edit-block {
    position: absolute;
    right: 10px;
    z-index: 99;
    .edit-btn {
      border: none;
      padding: 0;
      .edit-icon {
        display: flex;
        align-items: center;
        margin-right: 10px;
        color: #111111;

        img {
          margin-right: 6px;
          width: 18px;
          margin-bottom: 3px;
          height: 18px;
        }
      }
      &:hover {
        background-color: transparent !important;
        color: #111111;
      }
    }
  }
  .upload-lab-logo {
    .lab-logo {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 10px 20px;
      h3 {
        color: #111111;
        font-size: 18px;
        font-weight: 500;
        padding-right: 15px;
      }
      .preview-image {
        img {
          max-height: 175px;
          min-height: 75px;
          width: 70%;
          object-fit: contain;
        }
      }
    }
    .admin-lab-view-upload-logo {
      .el-upload {
        padding: 10px;
        width: 100%;

        .el-upload-dragger {
          width: 95%;
          height: 75px;
          background: #eef2f5;
          border: 1px dashed #bababc;
          border-radius: 5px;
        }
      }
      .el-upload-text-align {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        .el-upload__text {
          display: flex;
          align-items: center;

          h3 {
            color: #333333;
            font-size: 18px;
            padding: 0 10px;
          }
        }
      }
      .el-upload-notes {
        color: #828282;
        font-size: 14px;
        font-weight: 500;
        padding: 10px 5px;
      }
    }
    .el-upload-list__item:first-child {
      width: 80%;
      border: 0.5px solid #e0e0e0;
      border-radius: 5px;
      margin: 0 10px 10px;
    }
    .el-upload-list__item.is-success .el-upload-list__item-name:hover {
      color: black;
    }
    .el-upload-list__item-status-label {
      top: 3px;
    }
    .el-upload-list__item .el-icon--upload-success {
      color: #eb5757;
    }
  }
  .case-creation__actions {
    .list {
      padding: 10px 0px;

      li {
        .upload-button {
          color: #273480;
          background: #ffffff;
          border: 0.72px solid #dedbdb;
          border-radius: 5px;
          padding: 5px 10px;
          min-height: 34px;
          img {
            position: relative;
            top: 1px;
          }
        }
      }
    }
  }

  .sample-attachment-upload-file-block {
    .sample-attachment-upload-file {
      li {
        .file-name-attachment {
          display: grid;
          grid-template-columns: 30px auto 35px;
          align-items: center;
          padding: 0px 10px 7px 0px;
          border: 0.5px solid #e0e0e0;
          border-radius: 5px;
          width: 98%;
          height: 30px;
          margin: 1rem 0;
          img {
            padding: 0 10px;
            height: 15px;
            width: 15px;
          }
          p {
            color: #4f4f4f;
            white-space: nowrap;

            overflow: hidden;
            text-overflow: ellipsis;
          }
          .el-button {
            .without-hover {
              display: none;
              transition: all 0.2s ease-in-out;
            }
            .hover {
              display: block;
              transition: all 0.2s ease-in-out;
            }
            &:hover {
              .without-hover {
                display: block;
                transition: all 0.2s ease-in-out;
              }
              .hover {
                display: none;
                transition: all 0.2s ease-in-out;
              }
            }
          }
        }
      }
    }
  }
}
</style>
